import { Currency } from "@redotech/money/currencies";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const MoneySchema = z.object({
  amount: z.string(),
  currencyCode: createEnum(Currency, { enumName: "Currency" }),
});
const PriceSetSchema_ = z.object({
  shopMoney: MoneySchema,
  presentmentMoney: MoneySchema,
});

export const PriceSetSchema: z.ZodType<PriceSet> = PriceSetSchema_;
export interface PriceSet extends z.infer<typeof PriceSetSchema_> {}
